import { createContext, useContext } from 'react';

type SideNavMenuContextProps = {
  /** The grouping accordion in the menu that is currently open. The key is the grouping display name */
  activeGrouping: string | undefined;
  /** Function to update the grouping accordion that should be open */
  setActiveGrouping: (grouping: string | undefined) => void;
};

export const SideNavMenuContext = createContext<SideNavMenuContextProps | null>(null);

export const useSideNavMenu = () => {
  const context = useContext(SideNavMenuContext);

  if (context === null) {
    throw new Error('useSideNavMenu must be used within a SideNavMenuProvider');
  }

  return context;
};
